<nb-card>
    <nb-card-body>
        <nb-tabset fullWidth>
            <nb-tab *ngFor="let tab of numbers" 
            [tabTitle]="tab.tabTitle"
            [tabIcon]="tab.tabIcon" responsive>
                <slot [name]="tab.tabID"></slot>
            </nb-tab>
        </nb-tabset>
    </nb-card-body>
</nb-card>